export interface IHasDisplayName {
  displayName: string;
}

export default function sortByDisplayName(
  first: IHasDisplayName,
  second: IHasDisplayName
): number {
  return first?.displayName?.localeCompare(second?.displayName);
}
